const getEnv = (key: keyof ImportMetaEnv): string | never => {
  const env = import.meta.env[key] as string | undefined;
  if (env == null || env === '') {
    throw new Error(`environment variable "${String(key)}" is empty`);
  }
  return env;
};

export const getProxyUrl = () => getEnv('REACT_APP_PROXY_API_URL');
export const getNginxHost = () => {
  const envNginx = getEnv('REACT_APP_NGINX_HOST');
  if (import.meta.env.PROD) {
    // eslint-disable-next-line no-restricted-globals
    return `${location.protocol}//${window.location.hostname}/${envNginx}/`
  } else {
    return envNginx;
  }
}